import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
export function Guarantee() {
  return <section className="bg-white px-4 py-5" data-id="element-67" data-mp="1o33tsfx1zqh8">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-2xl border border-brand-line bg-brand-cream p-3.5 shadow-sm" data-id="element-68" data-mp="223epbw9b5t8q">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-69" data-mp="1x5d5va7yzrwq" />
        <div data-id="element-70" data-mp="19dzdx5dqdyca">
          <h2 className="mb-1 font-display text-base font-extrabold uppercase leading-tight sm:text-xl" data-id="element-71" data-mp="19firupbwzxaw">
            Votre achat est protégé à 100 %
          </h2>
          <p className="text-xs font-medium leading-snug text-brand-muted sm:text-base" data-id="element-72" data-mp="1j4ai8t1bu9jp">
            Vous disposez de 14 jours complets pour découvrir {PRODUCT_NAME}, étudier les modules,
            utiliser les checklists, suivre les procédures, analyser les exemples et commencer à
            appliquer le système. Si pendant cette période vous décidez que {PRODUCT_NAME} ne vous
            convient pas, contactez-nous dans les 14 premiers jours et vous recevrez le remboursement
            intégral de votre achat. Sans risque.
          </p>
        </div>
      </div>
    </section>;
}